
import { notification } from 'antd'
import PropTypes from 'prop-types'
import { forwardRef, useEffect, useImperativeHandle, useState } from 'react'
import { deepCopy } from '../../../tools/arrayObject'
import { TableContext } from './contextManager'
import './ProductContextWrap.less'
import { FactorTable } from './tablesTemplate'

/**
 * 产品详情：单条产品，数据相关的表体（影响因子、缴费年期、首年。。。）
 * @param props
 * @returns {*}
 * @constructor
 */
const ProductContextWrap = forwardRef((props, ref)=>{
  const {rateDetail, productType} = props.data
  const cacheData = deepCopy(rateDetail)
  let spuCollectionType =1; // 1产品配置  2条款配置
  let rateType = 1; // 1机构模板，2机构，3团队，4团队模板
  if(rateDetail?.spuCollectionType){
    spuCollectionType = rateDetail.spuCollectionType;
  }
  if(rateDetail?.rateType) {
    rateType = rateDetail.rateType;
  }
  const [tableData, setTableData] = useState(cacheData) // rateDetail
  const hasActive =  props.hasActive || false; // 是否有活动
  const isShortInsClass = props.isShortInsClass || false // 是否是短险(由外部控制是否使用)
   //   改版变更字段记录：
   // * commission -- spuCollections
   // * feeList --   rateGroupings
   // * rateValues -- rateInfos
  useEffect(()=>{
    setTableData(deepCopy(props.data.rateDetail))
  },[props.data])

  useEffect(()=>{
    !!props.isEdit && setTableData(initEditTableData(tableData))
  },[props.isEdit])

  useImperativeHandle(ref, ()=>({
    getChangedData: tableData
  }))

  /**
   * 更改影响因子
   * @spuCollectionsKey  主附险index
   * @factorKey 影响因子index
   */
  const changeFactor = (spuCollectionsKey, factorKey, val) => {
    // 主附险
    const _tableData = {...tableData}
    _tableData.spuCollections[spuCollectionsKey].rateGroupings[factorKey].rateInfos = val
    setTableData(_tableData)
  }
  // 配费表格数据初始化(上级可支配大于0，可编辑；默认初始化为0，)
  const initEditTableData = (data) => {
    const isOrg = (rateType === 1 || rateType === 2)// 机构/团队
    !!data.spuCollections.length && data.spuCollections.forEach((mainOrSub, index) => { // 主 附险
      mainOrSub.rateGroupings.forEach((rateGroup, g) => {
        rateGroup.rateInfos.forEach((rateInfo, j) => {
          if (isOrg) { // 机构
            initRateRow(rateInfo, 'letout', isShortInsClass)
          } else { // 团队
            initRateRow(rateInfo, 'group', isShortInsClass)
            initRateRow(rateInfo, 'agency', isShortInsClass)
          }
        })
      })
    })
    return data
  }
  /**
   * 初始化可编辑行的配费数据
   * rateInfo {} 配费信息
   * key string 可配费key名
   * isShort boolean 是否短险
   */
  const initRateRow = (rateInfo, key, isShort) => {
    let result = isShort ? { firstRate: 0, secondRate: 0 } : { firstRate: 0, secondRate: 0, thirdRate: 0, fourthRate: 0, fifthRate: 0 }
    Object.assign(result, rateInfo[key])
    deleteUnEditable(rateInfo.receivable, result)
    rateInfo[key] = result
  }
  // 根据receivable值, 如果<=0 删掉对应target值
  const deleteUnEditable = (receivable, target) => {
    if(Object.keys(receivable).length===0){
      return {}
    }
    for (let key in target) {
      if (receivable[key] * 1 <= 0) { // 上级机构 费>0 才可编辑
        delete target[key]
      }
    }
  }

  return(
    // isFromRepository 是否来自产品库
    <TableContext.Provider value={{
      isEdit: props.isEdit,
      isFromRepository: props.isFromRepository,
      productType,
      hasActive,
      rateType,
      isShortInsClass
    }}>
      {/*useContext 子组件直接修改data,路径太长啦*/}
      {
        (tableData?.spuCollections || []).map((factorList,spuCollectionsKey)=>{ // 主附险 分组
          return(
            <div key={spuCollectionsKey} className={`temp-table-context-wrap ${!!props.isEdit && 'eidt'} ${!!props.bordered && 'bordered'}`}>
              {/*主附险 头*/}
              {
                (spuCollectionType === 2 || props.spuId === '1856554204082036736' || props.spuId ==='1861316491690991616' ) &&
                <div className={'main-sub'}>
                  {
                    (props.spuId === '1856554204082036736' || props.spuId ==='1861316491690991616') ? <span className={'join'}>{factorList.spuCollectionName ||''}</span>: factorList.mainClauseFlag?
                      <span className={'main'}>{factorList.spuCollectionName ||''}</span>:
                      <span className={'sub'}>{factorList.spuCollectionName ||''}</span>
                  }
                </div>
              }
              {
                (factorList.rateGroupings && factorList.rateGroupings.length>0 )&&
                  factorList.rateGroupings.map((factordata,key)=>{ //影响因子factordata.rateCode
                  return <FactorTable key={key}
                                      isTop={tableData.isTop || props.data.isTop}
                                      spuCollectionsKey={spuCollectionsKey}
                                      factorKey={key}
                                      data={factordata}
                                      changeFactor={changeFactor}/>
                })
              }
              {/*<FactorTable data={FactorList}/>*/}
            </div>
          )
        })
      }
    </TableContext.Provider>
  )
})
ProductContextWrap.propTypes= {
  data: PropTypes.object,
  hasActive: PropTypes.bool, // 是否有活动
  isShortInsClass: PropTypes.bool, /*是否是短险样式*/
  isEdit: PropTypes.bool,
  isFromRepository: PropTypes.bool // 是否来自产品库
}

/**
 * 表格-剩余是否包含负数；配置是否含空
 * @param data 表格数据
 * @returns {boolean}
 */
export const numCheckePassed = (data) =>{
  let payTypeList = []; // 剩余费率集合[[first,second],[]...]
  let nullList = []; // 是否含有null集合
  let _data = deepCopy(data)
  _data.spuCollections.forEach((spuCollectionsItem, item)=>{
    spuCollectionsItem.rateGroupings.forEach((factorList,j)=>{
      factorList.rateInfos.forEach((payPeriodType,k)=>{
        const {receivable={}, letout={}, group={}, agency={}, surplus={}} = payPeriodType
        // const {surplus={}} = payPeriodType
        payTypeList = payTypeList.concat(surplus)
        const _currentRow = checkNullWithoutZero({receivable, letout, group, agency})
        nullList = nullList.concat(_currentRow)
      })
    })
  })
// console.log(nullList)
  const hasNullIndex = nullList.findIndex(feeRow=>{
    let index = Object.values(feeRow).findIndex(fee=>{
      return fee===''
    })
    return index>-1
  })

  const hasMinusIndex = payTypeList.findIndex(feeRow=>{
    let index = Object.values(feeRow).findIndex(fee=>{
      return  fee*1<0
    })
    return index>-1
  })

  if(hasMinusIndex>-1){  // 存在负数
    notification.error({
      message: '推广费分配不得大于所属机构可支配',
    })
    return false
  }
  if(hasNullIndex>-1){ // 存在空   // 暂去掉非空校验@刘隽
    notification.warning({
      message: '请先配置推广费费率',
    })
    return false
  }
  return true
}
/** 辅助校验配费不能为空的情况（排除掉上级为0时费不可编辑影响不为空校验）@liujun
 * 可支配为0时，当前机构/团队/剩余不可编辑，因此不再校验是否为空，此处赋值为'0。00'仅作为判断是否为空时使用，不再校验相应年份
 * @param receivable
 * @param letout
 * @param group
 * @param agency
 * @returns {[*, *, *]}
 */
const checkNullWithoutZero = ({receivable, letout, group, agency})=>{
  let values =  Object.values(receivable);
  let keys = Object.keys(receivable)
  values.forEach((fee,index)=>{
    if(fee==='0' || fee==='0.00' ||  fee=== '0.0'){
      let key = keys[index]
      letout[key] ='0.00'
      group[key] ='0.00'
      agency[key] ='0.00'
    }
  })
  return [letout, group, agency]
}

export default ProductContextWrap
